// Utils / constants
import { isSameModule } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/utils/custom-pdf-report-builder-utils';
import cloneDeep from 'lodash.clonedeep';
import { MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX, MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN, } from '../features/custom-pdf-report-modal/constants';
import { PAGE_SIZE_MAX, TEARSHEET_PAGE_SIZE_CONVERSION_FACTOR, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
// Interfaces / enums
import { CustomPDFReportType } from '../enums/custom-pdf-report-type.enum';
export const hasCorrectNumberOfComparisonSecurities = (comparisonSecurities) => {
    return (comparisonSecurities.length <= MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX &&
        comparisonSecurities.length >= MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN);
};
export const hasValidReportSecurities = (reportType, primarySecurity, secondarySecurity, comparisonSecurities) => {
    let valid;
    switch (reportType) {
        case CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW:
            valid = !!primarySecurity.securityId;
            break;
        case CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && secondarySecurity.securityId);
            break;
        case CustomPDFReportType.MULTI_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && hasCorrectNumberOfComparisonSecurities(comparisonSecurities));
            break;
        case CustomPDFReportType.PRESENTATION:
            valid = true;
            break;
        case CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && hasCorrectNumberOfComparisonSecurities(comparisonSecurities));
            break;
        case CustomPDFReportType.TEARSHEET_SINGLE_SECURITY:
            valid = !!primarySecurity.securityId;
            break;
        default:
            valid = false;
            break;
    }
    return valid;
};
export function isCustomPDFReport(report) {
    return Object.values(CustomPDFReportType).includes(report.report_type);
}
export function getSectionsWithModules(sections, modules) {
    const newSections = cloneDeep(sections);
    const flattenedModules = modules
        .map((page, index) => {
        return page.map((module) => ({
            ...module,
            y_coordinate: module.y_coordinate * TEARSHEET_PAGE_SIZE_CONVERSION_FACTOR + index * PAGE_SIZE_MAX,
        }));
    })
        .flat();
    if (sections.length && sections[0].modules) {
        newSections.forEach((section) => {
            const sectionModules = [];
            section.modules.forEach((sectionModule) => {
                const module = flattenedModules.find((m) => isSameModule(m, sectionModule));
                if (module) {
                    sectionModules.push(module);
                }
            });
            // eslint-disable-next-line no-param-reassign
            section.modules = sectionModules;
        });
    }
    return newSections;
}
export function getSortedSections(sections) {
    return [...sections].sort((a, b) => {
        // Get the first module for sections A and B
        const minA = a.modules.reduce((min, m) => {
            if (m.y_coordinate === min.y_coordinate
                ? m.x_coordinate < min.x_coordinate
                : m.y_coordinate < min.y_coordinate) {
                return m;
            }
            return min;
        });
        const minB = b.modules.reduce((min, m) => {
            if (m.y_coordinate === min.y_coordinate
                ? m.x_coordinate < min.x_coordinate
                : m.y_coordinate < min.y_coordinate) {
                return m;
            }
            return min;
        });
        // Compare by page, then y_coordinate
        if (minA.y_coordinate !== minB.y_coordinate) {
            return minA.y_coordinate - minB.y_coordinate;
        }
        return minA.x_coordinate - minB.x_coordinate;
    });
}
